export interface N11OrderProduct {
  sku: string;
  productName: string;
  quantity: number;
}

export const n11OrderProductFromResponse = (
  responseData: any,
): N11OrderProduct => ({
  sku: responseData.sku,
  productName: responseData.product_name,
  quantity: responseData.quantity,
});
